<page-heading
  [title]="'integrations.agendorList.heading' | translate"
  [description]="'integrations.agendorList.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-9 input-trend-search">
            <input
              type="search"
              #searchBox
              class="form-control"
              [placeholder]="'integrations.agendorList.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)"
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="showNewWebhook()">
              {{ 'integrations.agendorList.addButton' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  @if (!loadingContent && !pager.list?.length) {
  <empty-records-legacy-component
    [labelButton]="('integrations.agendorList.emptyAddButton' | translate)"
    [buttonClass]="'btn btn-info fw-bold'"
    [subMessage]="('integrations.agendorList.emptySubMessage' | translate)"
    [message]="('integrations.agendorList.emptyMessage' | translate)"
    (emitEvent)="showNewWebhook()"
  />
  } @if(!loading && processedList.length > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'integrations.agendorList.columnCreatedAt' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.agendorList.columnName' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.agendorList.columnStatus' | translate }}</th>
          <th>
            <span class="sr-only"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (integration of processedList; track $index) {
        <tr>
          <td>
            <span>
              {{
                integration.createdAt
                  | timezoneDate
                    : "DD/MM/YYYY"
                    : getTimezoneCompanyCurrentUser()
              }}
            </span>
          </td>
          <td>
            <strong class="text-truncate">{{ integration.name }}</strong>
          </td>
          <td>
            <span>
              {{ integration.actived ? ('integrations.agendorList.statusActive' | translate) : ('integrations.agendorList.statusTestMode' | translate) }}
            </span>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
                type="button"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="editIntegration(integration)"
                >
                  {{ 'integrations.agendorList.menuEdit' | translate }}
                </button>
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="removeIntegration(integration)"
                >
                  {{ 'integrations.agendorList.menuRemove' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)" />
    }
  </div>
  }
</div>
